<template>
  <div class="uploader-file" :class="'upload-' + status">
    <div class="uploader-file-progress"></div>
    <div class="uploader-file-info">
      <div class="uploader-file-name">
        <i class="uploader-file-icon" :icon="fileCategory"></i>
        <a :href="getDownloadUrl(file.uploadFileID, file.fileToken)" v-if="showNameAsLink === true" target="_blank">
          <font-awesome-icon icon="paperclip" :class="'iconpaperclip'" v-if="bijlageicon === true" />
          &nbsp;{{ file.name }}
        </a>
        <span v-if="showNameAsLink === false">{{ file.name }}</span>
      </div>
      <div class="uploader-file-size"></div>
      <div class="uploader-file-meta"></div>
      <div class="uploader-file-status">
        <span v-show="status !== 'uploading'">{{ statusText }}</span>
      </div>
      <div class="uploader-file-date" v-if="file.uploadDate !== null">
        <span>{{ datum }}</span>
      </div>
      <div class="uploader-file-actions">
        <span class="uploader-file-remove" @click="remove"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { FAMixin, util } from 'pevueglobal'
const COMPONENT_NAME = 'uploader-fileSaved'

export default {
  name: COMPONENT_NAME,
  props: {
    file: {
      type: Object,
      default() {
        return {}
      },
    },
    list: {
      type: Boolean,
      default: false,
    },
    showNameAsLink: {
      type: Boolean,
      default: true,
    },
    bijlageicon: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [FAMixin],
  data() {
    return {
      size: 0,
      type: '',
      extension: '',
      progressingClass: '',
    }
  },
  computed: {
    statusText() {
      return this.file.errormessage
    },
    datum() {
      if (this.file.uploadDate !== null) {
        return util.JSdatetimestring(new Date(this.file.uploadDate))
      } else {
        return ''
      }
    },
    fileCategory() {
      const extension = this.extension
      let type = 'unknown'
      const typeMap = {
        image: ['gif', 'jpg', 'jpeg', 'png', 'bmp', 'webp'],
        video: ['mp4', 'm3u8', 'rmvb', 'avi', 'swf', '3gp', 'mkv', 'flv'],
        audio: ['mp3', 'wav', 'wma', 'ogg', 'aac', 'flac'],
        document: [
          'doc',
          'txt',
          'docx',
          'pages',
          'epub',
          'pdf',
          'numbers',
          'csv',
          'xls',
          'xlsx',
          'keynote',
          'ppt',
          'pptx',
        ],
      }
      Object.keys(typeMap).forEach((_type) => {
        const extensions = typeMap[_type]
        if (extensions.indexOf(extension) > -1) {
          type = _type
        }
      })
      return type
    },
    status() {
      if (this.file.error === false) {
        return 'success'
      } else {
        return 'error'
      }
    },
  },
  watch: {},
  methods: {
    remove() {
      this.$emit('removed', this.file)
    },
  },
  mounted() {
    this.extension = this.file.extension
  },
  destroyed() {},
}
</script>

<style>
.upload-success .uploader-file-name {
  margin-left: 0;
  margin-right: auto;
}
.uploader-file-date {
  padding-left: 20px;
  padding-right: 20px;
}
</style>
